import { create } from 'zustand';

export type SetActivePaywallModal = (
  modalContent: React.JSX.Element | null,
) => void;

export const usePaywallModalsStore = create<{
  activePaywallModalContent: React.JSX.Element | null;
  setActivePaywallModal: SetActivePaywallModal;
  closePaywallModal: () => void;
  open: boolean;
}>((set) => ({
  activePaywallModalContent: null,
  open: false,
  closePaywallModal: () => set({ open: false }),
  setActivePaywallModal: (modalContent) =>
    set({
      activePaywallModalContent: modalContent,
      open: true,
    }),
}));
